export function sendFilterEvent(filter, value, action) {
    let items = {
            'event': 'serp_filter',
            'filter_by': filter,
            'filter_value': value
        };
    if (typeof action !== "undefined") {
        items.filter_action = action;
    }
    dataLayer.push(items);
}